import { defineMessages } from '@jutro/locale';

export default defineMessages({
    priorInsuranceHeader: {
        id: 'gw.capability.gateway.quoteandbind.pa.react.components.MLCRPriorInsuranceValidationComponent.priorInsuranceHeader',
        defaultMessage: 'Prior Insurance'
    }
    
});